import type { UserDTO } from '@/generated'

export function userDTOtoDisplayName(user: UserDTO): string {
  if (!user.title && !user.firstName && !user.lastName) {
    return user.userName
  }

  return `${user.title ? user.title + ' ' : ''}${user.firstName} ${user.lastName}`
}
